// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js??ref--6-2!./all.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("1779ba13", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./static/fontawesome-5.10.2/css/all.css
// module id = 331
// module chunks = 1